import {
  IonContent,
  IonFooter,
  IonItem,
  IonList,
  IonListHeader,
  IonSkeletonText,
} from "@ionic/react";
import React from "react";

const Skeleton__OptionsGridForm: React.FC = () => {
  // Pre-defined widths to give the checkboxes an organic, staggered look
  // without using Math.random() which can cause render jitter.
  const checkboxWidths = ["40%", "60%", "35%", "55%", "45%", "50%"];

  return (
    <>
      <IonContent>
        <div
          className="first-options-grid-screen"
          style={{ paddingTop: "10px" }}
        >
          {/* Underlying Future Selection Skeleton */}
          <IonList inset={true}>
            <IonItem lines="none" color="light">
              <IonSkeletonText
                animated
                style={{ width: "40%", height: "16px", borderRadius: "4px" }}
                slot="start"
              />
              <IonSkeletonText
                animated
                style={{ width: "20%", height: "16px", borderRadius: "4px" }}
                slot="end"
              />
            </IonItem>
          </IonList>

          {/* Expiry Selection Skeleton */}
          <IonList inset={true}>
            <IonItem lines="none" color="light">
              <IonSkeletonText
                animated
                style={{ width: "25%", height: "16px", borderRadius: "4px" }}
                slot="start"
              />
              <IonSkeletonText
                animated
                style={{ width: "30%", height: "16px", borderRadius: "4px" }}
                slot="end"
              />
            </IonItem>
          </IonList>

          {/* Greeks Selection Skeleton */}
          <IonList inset={true}>
            <IonItem lines="none" color="light">
              <IonSkeletonText
                animated
                style={{ width: "35%", height: "16px", borderRadius: "4px" }}
                slot="start"
              />
              <IonSkeletonText
                animated
                style={{ width: "40%", height: "16px", borderRadius: "4px" }}
                slot="end"
              />
            </IonItem>
          </IonList>

          {/* Option Category Header Skeleton */}
          <IonListHeader>
            <IonSkeletonText
              animated
              style={{ width: "35%", height: "18px", borderRadius: "4px" }}
            />
          </IonListHeader>

          {/* Option Category Checkboxes Skeleton */}
          <IonList inset={true}>
            {checkboxWidths.map((width, index) => (
              <IonItem color="light" key={index}>
                {/* Simulating the checkbox square */}
                <IonSkeletonText
                  animated
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "4px",
                    marginRight: "16px",
                  }}
                  slot="start"
                />
                {/* Simulating the category label */}
                <IonSkeletonText
                  animated
                  style={{ width: width, height: "14px", borderRadius: "4px" }}
                />
              </IonItem>
            ))}
          </IonList>
        </div>
      </IonContent>

      {/* Footer Search Button Skeleton */}
      <IonFooter className="ion-padding">
        <IonSkeletonText
          animated
          style={{
            width: "100%",
            height: "44px",
            borderRadius: "6px",
            margin: "0",
          }}
        />
      </IonFooter>
    </>
  );
};

export default Skeleton__OptionsGridForm;
